import type { PageLoad } from './$types';
import api from '$lib/utils/api';
import { date } from 'typesafe-i18n/formatters';
import type { AnnouncementPreview } from '$lib/types/view-models';
import slugify from '@sindresorhus/slugify';

export const load: PageLoad = async ({ fetch, parent, params, url }) => {
	const a = api(fetch);

	const { locale } = await parent();
	const oppositeLocale = locale === 'en' ? 'fr' : 'en';

	const activityOptions: any = await a.getActivityOptions(locale) ?? await a.getActivityOptions('fr');

	const types =
		activityOptions?.attributes.headlinesSections.map((type) => ({
			label: type.label.trim(),
			value: slugify(type.label),
			items: type.sources.data.map((subtype) => ({
				id: subtype.id,
				label: subtype.attributes.label.trim(),
				value: slugify(subtype.attributes.label.trim()),
			})),
		})) ?? [];

	const activities = {
		[locale]: await a.getActivities(locale, {
			sort: 'dateIssued:desc',
		}),
		[oppositeLocale]: await a.getActivities(oppositeLocale, {
			sort: 'dateIssued:desc',
		}),
	};


	activities[oppositeLocale].items = activities[oppositeLocale].items.filter(
		(item) => !activities[locale].items.map((item) => item.localizations[0].id).includes(item.id),
	);

	
	const activitiesList = { items: [...activities[oppositeLocale].items, ...activities[locale].items] };

	const filters = {
		date: {
			label: 'Dates',
			items: Array.from(new Set(activitiesList.items.map((item) => item.dateIssued.getFullYear())))
				.sort()
				.reverse()
				.map((year) => ({
					label: year.toString(),
					value: year.toString(),
				})),
			callback: (item, value) => {
				return item.dateIssued.getFullYear() == value;
			},
		},
		type: {
			label: 'Types',
			items: types,
			callback: (item, value) => {
				return item.categories?.some((category) =>
					types.find((type) => type.value === value).items.some((subtype) => subtype.id === category.id),
				);
			},
		},
		tags: {
			label: 'Mot-clés',
			items: activitiesList.items
				.flatMap((item) => item.tags?.map((tag) => ({ value: tag.slug, label: tag.label })))
				.filter((tag, index, array) => array.findIndex((item) => tag?.value == item?.value) === index)
				.sort((a, b) => a.label.localeCompare(b.label))
				.filter(Boolean),
			callback: (item, value) => {
				return item.tags?.some((category) => category.slug === value);
			},
		},
	};
	
	return {
		activities: activitiesList,
		filters,
	};
};
